import { useEffect, useRef, useState } from 'react'

interface IUseExitAnimationParams {
  disappearDuration: number
  realIsOpen: boolean
}

export const useExitAnimation = ({ disappearDuration, realIsOpen }: IUseExitAnimationParams) => {
  // eslint-disable-next-line no-undef
  const deleteElementFromDomTimeout = useRef<NodeJS.Timeout>()

  const [isElementInDom, setIsElementInDom] = useState<boolean>(realIsOpen)
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)

  useEffect(() => {
    if (realIsOpen && !isFirstRender) {
      setIsElementInDom(true)
    }

    if (!realIsOpen && !isFirstRender) {
      deleteElementFromDomTimeout.current = setTimeout(() => {
        setIsElementInDom(false)
      }, disappearDuration)

      return () => {
        clearTimeout(deleteElementFromDomTimeout.current)
      }
    }

    setIsFirstRender(false)

    return () => {}
  }, [realIsOpen])

  useEffect(
    () => () => {
      clearTimeout(deleteElementFromDomTimeout.current)
    },
    [],
  )

  return isElementInDom
}
